let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("96INv")).then(() => parcelRequire('g4KKw'));